import { Injectable } from '@angular/core';
import { HttpClient } from './global-http.service';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { IEventApiParams, IEventsListItem } from '../_models/tracker';

import { Utilities } from '../_utilities/Utilities';

@Injectable()
export class EventsService {

  data: any;

  constructor(private http: HttpClient) { }

  /**
   * Event list
   * Example '/api/events/?vehicle=13245&start=2019-07-04T01:00:00Z&end=2019-07-05T01:00:00Z&event=4&event=5
   * @param vehicle=132
   * @param start=2019-07-04T01:00:00Z
   * @param end=2019-07-05T01:00:00Z
   * @param event=4 - Int from tracker event code. Pass in multiple event params e.g. &event=4&event=5
   *
   */
  findEvents(params: IEventApiParams): Observable<IEventsListItem[]> {
    let _paramsKeys = '';
    let _paramsEvents = '';
    let _qs = '';
    const _events = params.events;
    delete params.events; // Remove the events so we can format the param keys
    _paramsKeys = Object.keys(params).map(key => key + '=' + params[key]).join('&');
    _paramsEvents = _events.map(key => {
      if (key.eventCode !== -1) {
        return 'event=' + key.eventCode;
      }
    }).join('&');

    _qs = _paramsKeys + '&' + _paramsEvents;
    // Test
    // _qs = 'vehicle=13245&start=2019-07-04T01:00:00Z&end=2019-07-05T01:00:00Z&event=4&event=5';

    const _url = `/api/events/?${_qs}`;
    return this.http.get<IEventsListItem[]>(_url);
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/events.service.ts